<template>
	<div>
		<v-row class="linha-filtros">
			<v-col cols="12" :sm="colunaSM.processo || 4">
				<label-personalizado
					:nome-campo="deveExibirCampoNumeroIntegracaoAtiva ? 'Número Edital' : 'Processo'"
					:obrigatorioPorPadrao="true"
				>
				</label-personalizado>
				<template v-if="deveExibirCampoNumeroIntegracaoAtiva">
					<v-combobox
						:disabled="temItemSelecionado"
						id="combo-combobox-processos"
						v-model="filtros.processo"
						v-validate="{ required: true }"
						name="Número"
						dense
						clearable
						:items="processos"
						no-filter
						:search-input.sync="filtroProcesso.numero"
						placeholder="Busque por número"
						class="pt-0"
						:debounce-search="250"
						item-value="id"
						item-text="numero"
						return-object
						@change="atualizarNumeroProcesso"
						@update:search-input.capture="carregarProcessos"
						@click:clear="limparFiltros()"
					></v-combobox>
				</template>
				<template v-else>
					<v-autocomplete
						:disabled="temItemSelecionado"
						id="combo-autocomplete-processos"
						v-model="filtros.processo"
						v-validate="{ required: true }"
						name="Processo"
						dense
						clearable
						:items="processos"
						no-filter
						:search-input.sync="filtroProcesso.numero"
						placeholder="Busque por número"
						class="pt-0"
						:debounce-search="250"
						item-value="id"
						item-text="numero"
						return-object
						@change="buscarFiltros()"
						@update:search-input.capture="carregarProcessos"
						@click:clear="limparFiltros()"
					></v-autocomplete>
				</template>
			</v-col>
			<template v-if="deveExibirCampoNumeroIntegracaoAtiva">
				<v-col cols="12" :sm="colunaSM.orgao">
					<label-personalizado nome-campo="Órgão Promotor"></label-personalizado>
					<v-autocomplete
						id="combo-autocomplete-orgao"
						v-model="filtros.orgao"
						:disabled="!filtroProcesso.numero || isCampoOrgaoAnoHabilitado"
						:items="orgaos"
						dense
						clearable
						item-text="siglaDescricao"
						item-value="id"
						placeholder="Selecione ou digite o órgão"
						class="pt-0"
						@update:search-input.capture="carregarOrgaos"
						:search-input.sync="orgaoDigitado"
					></v-autocomplete>
				</v-col>
				<v-col cols="12" :sm="colunaSM.ano">
					<label-personalizado nome-campo="Ano"></label-personalizado>
					<v-text-field
						id="input-ano"
						v-model="filtros.ano"
						:disabled="!filtroProcesso.numero || isCampoOrgaoAnoHabilitado"
						dense
						clearable
						placeholder="Digite o ano"
						class="pt-0"
						type="number"
						min="0"
						max="9999"
						:maxLength="4"
						@keyup="filterNumericInput"
					></v-text-field>
				</v-col>
			</template>
			<v-col cols="12" :sm="colunaSM.fornecedor">
				<label-personalizado nome-campo="Fornecedor"></label-personalizado>
				<v-autocomplete
					id="combo-autocomplete-fornecedor"
					v-model="filtros.idsFornecedores"
					name="Fornecedor"
					multiple
					dense
					clearable
					:disabled="!filtros.processo || !isCampoOrgaoAnoHabilitado"
					:items="fornecedores"
					no-filter
					placeholder="Todos"
					class="pt-0"
					:debounce-search="250"
					item-text="razaoSocial"
					item-value="id"
					:search-input.sync="filtros.razaoSocial"
					@update:search-input.capture="buscarFornecedores"
					@change="buscarFiltros()"
				>
					<template #selection="{ item, index }">
						<v-chip v-if="index < 1" class="chip-small chip-small__fornecedor">
							<span class="v-chip__content text-truncate">{{ item.razaoSocial }}</span>
						</v-chip>
						<span v-else-if="index === 1">+{{ filtros.idsFornecedores.length - 1 }}</span>
					</template>
				</v-autocomplete>
			</v-col>
			<v-col cols="12" :sm="colunaSM.tipo">
				<label-personalizado nome-campo="Tipo"></label-personalizado>
				<v-autocomplete
					id="combo-autocomplete-tipo-ata"
					v-model="filtros.idsTipos"
					name="Tipo"
					multiple
					dense
					clearable
					:disabled="!filtros.processo || !isCampoOrgaoAnoHabilitado"
					:items="tipos"
					no-filter
					placeholder="Todos"
					class="pt-0"
					:debounce-search="250"
					item-text="tituloFormatado"
					item-value="id"
					:search-input.sync="filtros.numero"
					@update:search-input.capture="buscarTipos"
					@change="buscarFiltros()"
				>
					<template #selection="{ item, index }">
						<v-chip v-if="index < 1" class="chip-small">
							<span class="v-chip__content text-truncate">{{ item.tituloFormatado }}</span>
						</v-chip>
						<span v-else-if="index === 1">+{{ filtros.idsTipos.length - 1 }}</span>
					</template>
				</v-autocomplete>
			</v-col>
			<!--			<v-col cols="12" sm="2">-->
			<!--				<label-personalizado nome-campo="Edital"></label-personalizado>-->
			<!--				<v-autocomplete-->
			<!--					id="combo-autocomplete-edital"-->
			<!--					v-model="filtros.numeroEditais"-->
			<!--					name="Edital"-->
			<!--					:menu-props="{ minHeight: 45 }"-->
			<!--					multiple-->
			<!--					dense-->
			<!--					clearable-->
			<!--					:disabled="!filtros.processo"-->
			<!--					:items="editais"-->
			<!--					no-filter-->
			<!--					placeholder="Todos"-->
			<!--					class="pt-0"-->
			<!--					item-text="numeroEdital"-->
			<!--					item-value="id"-->
			<!--					:debounce-search="250"-->
			<!--					:search-input.sync="filtros.numeroEdital"-->
			<!--					@update:search-input.capture="buscarEditais"-->
			<!--					@change="buscarFiltros()"-->
			<!--				>-->
			<!--					<template #selection="{ item, index }">-->
			<!--						<v-chip v-if="index < 1" class="chip-small chip-small__padrao">-->
			<!--							<span class="v-chip__content text-truncate">{{ item.numeroEdital }}</span>-->
			<!--						</v-chip>-->
			<!--						<span v-else-if="index === 1">+{{ filtros.numeroEditais.length - 1 }}</span>-->
			<!--					</template>-->
			<!--				</v-autocomplete>-->
			<!--			</v-col>-->
			<v-col cols="12" sm="2" class="align-self-center">
				<botao-primario
					class="ml-auto"
					block
					nome-botao="FILTRAR"
					@click="filtrar()"
					:disabled="
						deveExibirCampoNumeroIntegracaoAtiva
							? !filtros.processo || !filtros.ano || !filtros.orgao
							: !filtros.processo
					"
				></botao-primario>
			</v-col>
		</v-row>
		<v-divider class="mb-2"></v-divider>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/core/constants'

export default {
	name: 'modal-primeira-etapa-filtros',
	props: {
		temItemSelecionado: {
			type: Boolean,
			required: false,
		},
	},
	data() {
		return {
			processos: [],
			editais: [],
			fornecedores: [],
			tipos: [],
			orgaos: [],
			processoSelecionado: null,
			ano: null,
			anoAux: null,
			orgaoDigitado: null,
			isIntegracaoWeblicAtivo: this.$store.state.parametrosSistema.isIntegracaoWeblicAtivo,
			isCampoOrgaoAnoHabilitado: false,
			isCamposHabilitados: false,
		}
	},
	computed: {
		...mapState({
			filtros: (state) => state.itemProcesso.filtro,
			filtroProcesso: (state) => state.processo.filtro,
		}),
		deveExibirCampoNumeroIntegracaoAtiva() {
			return this.isIntegracaoWeblicAtivo
		},
		colunaSM() {
			return this.deveExibirCampoNumeroIntegracaoAtiva
				? { orgao: 6, ano: 2, fornecedor: 6, tipo: 4 }
				: { processo: 3, fornecedor: 4, tipo: 3 }
		},
	},
	watch: {
		filtros: {
			handler() {
				if (!this.filtros.processo) {
					this.fornecedores = []
					this.tipos = []
					this.limparFiltros()
				}
			},
			deep: true,
		},
	},
	async mounted() {
		await this.limparFiltros()
		await this.carregarProcessos()
		await this.carregarOrgaos()
	},
	methods: {
		async carregarProcessos() {
			const { itens } = await this.$store.dispatch(actionTypes.PROCESSO.BUSCAR_PROCESSOS_LISTAGEM)
			this.processos = itens

			this.isCampoOrgaoAnoHabilitado = this.validarProcessoSelecionado()
		},
		validarProcessoSelecionado() {
			if (this.filtros.processo) {
				return this.filtros.processo.id !== null && this.filtros.processo.id !== undefined
			}

			return false
		},

		async buscarFiltros() {
			if (this.filtros.processo) {
				this.filtros.idProcesso = this.filtros.processo.id
				this.filtros.ano = this.filtros.processo.anoProcesso
				this.filtros.orgao = {
					id: this.filtros.processo.idUoProcesso,
					sigla: this.filtros.processo.uoSiglaProcesso,
				}
				await this.carregarOrgaos()
				// await this.buscarEditais()
				await this.buscarFornecedores()
				await this.buscarTipos()
			}
		},
		async buscarEditais() {
			const { itens } = await this.$store.dispatch(
				actionTypes.ITEM_PROCESSO.EDITAL.BUSCAR_EDITAIS_POR_FILTRO,
				this.filtros,
			)
			this.editais = itens
		},
		async buscarFornecedores() {
			const { itens } = await this.$store.dispatch(
				actionTypes.FORNECEDOR.BUSCAR_FORNECEDORES_POR_FILTRO,
				this.filtros,
			)
			this.fornecedores = itens
		},
		async carregarOrgaos() {
			const orgaos = await this.$store.dispatch(
				actionTypes.PROCESSO.BUSCAR_ORGAOS_USUARIO_FILTRO,
				this.processoSelecionado?.idUoProcesso,
			)
			this.orgaos = orgaos.map((orgao) => ({
				id: orgao.id,
				nome: orgao.nome,
				sigla: orgao.sigla,
				siglaDescricao: orgao.siglaDescricao,
			}))
		},
		async buscarTipos() {
			const { itens } = await this.$store.dispatch(actionTypes.TIPO.BUSCAR_TIPOS_POR_PROCESSO, this.filtros)
			this.tipos = itens
		},
		async filtrar() {
			if (this.deveExibirCampoNumeroIntegracaoAtiva) {
				const payload = {
					anoProcesso: this.filtros.ano,
					numeroProcesso: this.filtros.processo,
					idOrgaoProcesso: this.filtros.orgao,
				}

				this.$emit('limpar-page')
				this.$emit('filtrar', payload)
				// await this.buscarFiltros()
				return
			}
			this.$emit('limpar-page')
			this.$emit('filtrar')
		},
		async limparFiltros() {
			this.$store.commit(mutationTypes.ITEM_PROCESSO.LIMPAR_FILTRO_LISTAGEM)
			this.$emit('limpar')
			this.camposAtivados = false
			this.processoSelecionado = null
		},
		async atualizarCampos() {
			if (this.filtros.processo && this.filtros.processo.id) {
				const processoSelecionado = this.processos.find((processo) => processo.id === this.filtros.processo.id)
				if (processoSelecionado) {
					this.processoSelecionado = processoSelecionado
					this.filtros.orgao = processoSelecionado.orgao || null
					this.filtros.ano = processoSelecionado.ano || null
					await this.buscarFiltros()
				} else {
					this.processoSelecionado = null
					this.filtros.orgao = null
					this.filtros.ano = null
				}
			} else {
				this.processoSelecionado = null
				this.filtros.orgao = null
				this.filtros.ano = null
			}
		},
		async atualizarNumeroProcesso() {
			await this.atualizarCampos()
			this.filtros.idsFornecedores = []
			this.filtros.idsTipos = []
		},
		validarProcesso() {
			if (this.filtros.processo) {
				const processoSelecionado = this.processos.find((processo) => processo.id === this.filtros.processo.id)

				if (processoSelecionado) {
					this.filtros.processo = processoSelecionado
					this.filtros.orgao = processoSelecionado.orgao
					this.filtros.ano = processoSelecionado.ano
				} else {
					this.filtros.orgao = null
					this.filtros.ano = null
				}
			}
		},

		filterNumericInput() {
			const valor = parseInt(this.filtros.ano)

			if (this.validarFaixaDoValor(valor)) {
				if (valor) {
					this.$set(this, 'anoAux', valor)
					//this.anoAux = valor
				}
				this.$set(this.filtros, 'ano', valor)
			} else {
				this.$set(this.filtros, 'ano', parseInt(this.anoAux))
			}
		},

		validarFaixaDoValor(valor) {
			return (valor >= 0 && valor <= 9999) || !valor
		},
	},
}
</script>
<style lang="stylus">
.linha-filtros
	padding .8rem 0 0 0

.chip-small {
	font-size: 12px !important;
	height: 24px !important;
	line-height: 22px !important;
	padding: 0 8px !important;

	&__fornecedor {
		max-width 90px !important;
	}

	&__padrao {
		max-width 50px !important;
	}
}
</style>
